import styled from '@emotion/styled'
import mq from 'theme/mediaQueries'

export const Filters = styled.div`
  ${mq({
    display: ['block', 'block', 'grid', 'grid'],
  })} 

  max-width: 92%;
  column-gap: 15px;
`

export const FiltersInputs = styled(Filters)`
  grid-template-columns: 25% 25% 50%;
`

export const FiltersSelects = styled(Filters)`
  grid-template-columns: 30% 30% 30% 10%;
`

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
`
